import { Reducer } from 'interfaces'
import { AdvisorDataState } from 'components/features/coaching/advisorStore/interfaces/state'
import { createEmptyCollection, concatCollections, normalize, setItemInCollection } from 'helpers/normalizeHelpers'
import { GetPublicAdvisorReviewsAction } from 'components/features/coaching/advisorStore/actions/publicAdvisorActions'
import * as findIndex from 'lodash/findIndex'
import { AdvisorsPatchReviewAction } from 'components/features/coaching/advisorStore/actions/advisorMeetingActions'
import { GetTopAdvisorsReviewsAction } from 'components/features/coaching/advisorStore/actions/advisorLandingPageActions'

export const reviewsReducer: Reducer<AdvisorDataState['reviews']> = (prevState = createEmptyCollection(), action) => {
  switch (action.type) {
    case GetPublicAdvisorReviewsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return concatCollections(prevState, normalize(action.payload.response.results, 'uid'))
    }

    case AdvisorsPatchReviewAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return setItemInCollection(prevState, action.payload.response, 'uid')
    }

    case GetTopAdvisorsReviewsAction.type: {
      if (action.meta !== 'success') {
        return prevState
      }

      return concatCollections(prevState, normalize(action.payload.response, 'uid'))
    }
  }
  return prevState
}

const INITIAL_REQUEST = {
  errorCode: null,
  isLoading: false,
  data: null,
  next: null,
  results: [],
}
export const reviewsPaginationReducer: Reducer<AdvisorDataState['reviewsPagination']> = (prevState = [], action) => {
  switch (action.type) {
    case GetPublicAdvisorReviewsAction.type: {
      let requestIndex = findIndex(prevState, action.payload.params)
      if (requestIndex === -1) {
        requestIndex = prevState.length
      }
      const prevRequest = prevState[requestIndex] || { ...INITIAL_REQUEST, ...action.payload.params }
      const nextState = [...prevState]

      if (action.meta === 'request') {
        nextState[requestIndex] = {
          ...prevRequest,
          isLoading: true,
        }
        return nextState
      }

      if (action.meta === 'fail') {
        nextState[requestIndex] = {
          ...prevRequest,
          isLoading: false,
          errorCode: action.payload.errorCode,
        }
        return nextState
      }

      const prevResults = prevRequest.results
      const nextResults = [
        ...prevResults,
        ...action.payload.response.results.map((item) => item.uid),
      ]

      const nextRequest = {
        ...prevRequest,
        isLoading: false,
        errorCode: null,
        ...action.payload.response,
        results: nextResults,
      }
      nextState[requestIndex] = nextRequest
      return nextState
    }

  }

  return prevState
}
